import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { SET_ESTOQUE_DADOS_INIT } from '../actionTypes';
import { setExcessoEstoqueSuccess, errorEstoqueMsg } from './actions';
import { atualizaExcessoEstoque } from 'src/integracoes/servicos/mongo-atlas/funcoes/empresas';
import { IEmpresaGrupo } from 'src/integracoes/servicos/mongo-atlas/modelos/IEmpresa';

// Atualizar Excesso Estoque -------------------------
const fetchAtualizaExcessoEstoque = async (empId: string, grupos: IEmpresaGrupo[]) => {
  const { status, mensagem } = await atualizaExcessoEstoque(empId, grupos);
  if (status) {
    return { isUpdated: true, msg: mensagem };
  } else {
    return { isUpdated: false, msg: mensagem };
  }
};

function* parceAtualizaExcessoEstoque({ payload }: { payload: any, type: any }) {
  const { empId, grupos } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizaExcessoEstoque, empId, grupos);
    if (isUpdated) {
      yield put(setExcessoEstoqueSuccess({ msg }));
    } else {
      yield put(errorEstoqueMsg({ msg }));
    }
  } catch (error: any) {
    yield put(errorEstoqueMsg({ msg: error.mensagem }));
  }
}

export function* watchAtualizaExcessoEstoque() {
  yield takeEvery(SET_ESTOQUE_DADOS_INIT, parceAtualizaExcessoEstoque);
}

// WATCHS ------------------------------------------------
export default function* rootSaga() {
  yield all([fork(watchAtualizaExcessoEstoque)]);
}
